const variants = {
  primary: 'bg-accent-500 hover:bg-accent-600 text-white focus-visible:ring-accent-500',
  secondary: 'bg-navy-800 hover:bg-navy-700 text-white focus-visible:ring-navy-700',
  outline: 'border-2 border-accent-500 text-accent-500 hover:bg-accent-500 hover:text-white focus-visible:ring-accent-500',
  'outline-white': 'border-2 border-white text-white hover:bg-white hover:text-navy-900 focus-visible:ring-white',
  ghost: 'text-accent-500 hover:text-accent-600 underline-offset-2 hover:underline focus-visible:ring-accent-500',
}

const sizes = {
  sm: 'px-4 py-2 text-sm',
  md: 'px-6 py-3 text-base',
  lg: 'px-8 py-4 text-lg',
}

export default function Button({
  variant = 'primary',
  size = 'md',
  as: Tag = 'button',
  className = '',
  children,
  ...props
}) {
  return (
    <Tag
      className={`inline-flex items-center justify-center gap-2 rounded-lg font-semibold transition-all duration-200 cursor-pointer focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 disabled:opacity-60 disabled:cursor-not-allowed ${variants[variant]} ${sizes[size]} ${className}`}
      {...props}
    >
      {children}
    </Tag>
  )
}
